enum SettingThirdButton {
  PASS_LOT = "pass_lot",
  RETRACT_BID = "retract_bid",
  CHANGE_PRICE = "change_price",
  BLOCK_BUTTONS = "block_buttons",
  BOOK_BID_FIRST = "book_bid_first",
  RUN_AUTO = "run_auto"
}

export default SettingThirdButton;
